import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BodyTextMedium } from '../Typography/Typography';
import * as styles from './Checkbox.module.scss';
const Name = 'Checkbox';
/**
 * @deprecated
 */
export const Checkbox = ({ name, onChange, value = false, label, testId, }) => {
    const handleClick = (event) => {
        onChange?.(event.target.checked);
    };
    return (_jsxs("label", { "data-testid": testId, "data-component": Name, className: styles.container, children: [_jsx("input", { type: "checkbox", name: name, className: styles.checkbox, checked: value, onChange: handleClick }), _jsx(BodyTextMedium, { as: "span", fontColor: "gray65", children: label })] }));
};
